/**
 The routing of this file will not show the layout.
 It is an independent new page.
 the contents of the file still need to log in to access
 */
import type { AppRouteModule } from '/@/router/types';

export const mainOutRoutes: AppRouteModule[] = [
  // 首页
  {
    path: '/index/:id?',
    name: 'home',
    redirect: '/home/index',
    component: () => import('/@/views/home/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('/@/views/sys/login/Login.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  // 验证隐私密码
  {
    path: '/verification',
    name: 'verification',
    component: () => import('/@/views/verification/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  // 认证
  {
    path: '/userAuth',
    name: 'auth',
    component: () => import('/@/views/mine/auth/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/membership',
    name: 'membership',
    component: () => import('/@/views/serve/membership/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
    // children: [

    // ],
  },
  {
    path: '/membership/information',
    name: 'information',
    component: () => import('/@/views/serve/membership/information.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/membership/pay',
    name: 'pay',
    component: () => import('/@/views/serve/membership/pay.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/membership/result',
    name: 'result',
    component: () => import('/@/views/serve/membership/result.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('/@/views/verification/forget/forget.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/verification/set',
    name: 'set',
    component: () => import('/@/views/verification/set.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/mine/updateInfo',
    name: 'updateUserInfo',
    component: () => import('/@/views/mine/userInfo/updateUserInfo.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/mine/userInfo',
    name: 'userInfo',
    component: () => import('/@/views/mine/userInfo/userInfo.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/mine/resetPwd',
    name: 'resetPwd',
    component: () => import('/@/views/mine/reset/resetPwd.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/mine/payRecord',
    name: 'payRecord',
    component: () => import('/@/views/mine/payRecord/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/mine/progress',
    name: 'progress',
    component: () => import('/@/views/mine/progress/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('/@/views/message/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('/@/views/home/search/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/serve/network',
    name: 'network',
    component: () => import('/@/views/serve/network/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/serve/productlist',
    name: 'productList',
    component: () => import('/@/views/products/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/serve/productinfo',
    name: 'productsInfo',
    component: () => import('/@/views/products/info.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('/@/views/agreement/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/serve/chat',
    name: 'chat',
    component: () => import('/@/views/serve/chat/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/serve/invoice',
    name: 'invoice',
    component: () => import('/@/views/serve/invoice/index.vue'),
    meta: {
      title: '',
      ignoreAuth: false,
      authorization: false,
    },
  },
  {
    path: '/serve/receipt',
    name: 'receipt',
    component: () => import('/@/views/serve/receipt/index.vue'),
    meta: {
      title: '电子收据核验',
      ignoreAuth: true,
      authorization: true,
    },
  },
];

export const mainOutRouteNames = mainOutRoutes.map((item) => item.name);
